const PURCHASE_PROOF_ADMIN_ROLES = new Set(['ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']);

/** Checks whether at least one role can manage the purchase-proof feature. */
export function canManagePurchaseProofSettings(roles: readonly (string | null)[]) {
  return roles.some((role) => role !== null && PURCHASE_PROOF_ADMIN_ROLES.has(role));
}

/** Converts the persisted purchase-proof setting into its enabled state. */
export function isPurchaseProofEnabled(value?: string | null) {
  return value === 'true';
}

/** Converts supported waiting-list setting representations into an enabled state. */
export function isWaitingListEnabled(value?: string | null) {
  return value === 'true' || value === '1';
}
